// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IAccountReportDto } from './IAccountReportDto';
import {
    IAccountReportDtoFromJSON,
    IAccountReportDtoFromJSONTyped,
    IAccountReportDtoToJSON,
    IAccountReportDtoToJSONTyped,
} from './IAccountReportDto';
import type { IReportCloseDto } from './IReportCloseDto';
import {
    IReportCloseDtoFromJSON,
    IReportCloseDtoFromJSONTyped,
    IReportCloseDtoToJSON,
    IReportCloseDtoToJSONTyped,
} from './IReportCloseDto';

/**
 * 
 * @export
 * @interface IListOfAccountsReportDto
 */
export interface IListOfAccountsReportDto {
    /**
     * 
     * @type {Array<IAccountReportDto>}
     * @memberof IListOfAccountsReportDto
     */
    report?: Array<IAccountReportDto>;
    /**
     * 
     * @type {IReportCloseDto}
     * @memberof IListOfAccountsReportDto
     */
    close?: IReportCloseDto;
}

/**
 * Check if a given object implements the IListOfAccountsReportDto interface.
 */
export function instanceOfIListOfAccountsReportDto(value: object): value is IListOfAccountsReportDto {
    return true;
}

export function IListOfAccountsReportDtoFromJSON(json: any): IListOfAccountsReportDto {
    return IListOfAccountsReportDtoFromJSONTyped(json, false);
}

export function IListOfAccountsReportDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IListOfAccountsReportDto {
    if (json == null) {
        return json;
    }
    return {
        
        'report': json['report'] == null ? undefined : ((json['report'] as Array<any>).map(IAccountReportDtoFromJSON)),
        'close': json['close'] == null ? undefined : IReportCloseDtoFromJSON(json['close']),
    };
}

export function IListOfAccountsReportDtoToJSON(json: any): IListOfAccountsReportDto {
    return IListOfAccountsReportDtoToJSONTyped(json, false);
}

export function IListOfAccountsReportDtoToJSONTyped(value?: IListOfAccountsReportDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'report': value['report'] == null ? undefined : ((value['report'] as Array<any>).map(IAccountReportDtoToJSON)),
        'close': IReportCloseDtoToJSON(value['close']),
    };
}

